// Provisioning API calls. Kept behind this thin module (rather than the page
// calling `api` directly) so the vendor endpoint comes from the registry and the
// page stays unaware of routing.
//
// Contract the server upholds, and the page depends on:
//   * A failure THROWS an Error whose `.message` is the vendor's own text and
//     whose `.code` is a machine code ('duplicate_name' | 'timeout' | 'auth' |
//     'not_configured' | 'vendor_error' | …). lib/api.js already attaches
//     `.code` from the JSON body.
//   * A PARTIAL success RESOLVES with `{ status: 'partial', partnerId, … }` — it
//     is not an exception. The account really exists in that case, so its id must
//     not be thrown away.
import { api } from './api';
import { vendorById } from '../config/provisioningVendors';

export const provisioningApi = {
  history: () => api.get('/api/provisioning'),

  create: (vendorId, values) => {
    const vendor = vendorById(vendorId);
    if (!vendor?.endpoint) {
      const err = new Error(`${vendor?.label || vendorId} provisioning isn't available yet.`);
      err.code = 'not_configured';
      return Promise.reject(err);
    }
    return api.post(vendor.endpoint, values);
  },

  // Completes a record that is created-but-unfinished. `path` comes from the
  // vendor registry's `incomplete.action` — 'retry-user' for Cove (attach the
  // missing admin user), 'convert-to-paid' for Keeper (switch billing on once
  // the client has activated). Never re-creates the account itself.
  complete: (recordId, path) => api.post(`/api/provisioning/${recordId}/${path}`),

  // Vendor-side deletion, where the vendor allows it. Keeper only permits this
  // BEFORE the admin activates; the server refuses afterwards rather than
  // failing at the vendor.
  remove: (recordId) => api.del(`/api/provisioning/${recordId}`),
};
